
import { useLanguageContext } from '../../contexts/LanguageContext';
import Dialog, { IDialogProps } from '../Dialog';
import { ActionButton } from '../Button';
import { Grid } from '@mui/material';
import TextField from '../TextField';
import { useAuthContext } from '../../contexts/AuthContext';
import { useEffect, useCallback, useMemo } from 'react';
import FormHelper from '../../helpers/FormHelper';
import UserService from '../../services/UserService';
import StringHelper from '../../helpers/StringHelper';
import ValidationHelper from '../../helpers/ValidationHelper';
import ImageField from '../ImageField';
import DefaultConstants from '../../data/Constants';
import useState from '../../hooks/useState';


interface IStateValues {
    fullName: string;
    email: string;
}

const MyProfileDialog: React.FunctionComponent<Pick<IDialogProps, 'title' | 'open' | 'handleClose'>> = ({ title, open, handleClose }) => {
    const { translate } = useLanguageContext();
    const { user } = useAuthContext();

    const state = useState<IStateValues>({
        fullName: '',
        email: ''
    });


    useEffect(() => {
        if (open) {
            state.update('fullName', user?.fullName ?? '');
            state.update('email', user?.email ?? '');
        }
        
        // eslint-disable-next-line
    }, [open]);


    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='cancel' onClick={handleClose} />,
            <ActionButton action='save' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = FormHelper.Create(event);
        UserService.UpdateProfile(formData).then(() => {
            if (user) {
                user.fullName = state.values.fullName;
                user.email = state.values.email;

                // Refresh avatar from user
                const avatar = user.avatar.split('?')[0];
                const randomText = StringHelper.RandomText(12, false, true, true, false);
                user.avatar = `${avatar}?uniq=${randomText}`;

                handleClose();
            }
        });

        // eslint-disable-next-line
    }, [state.values]);


    return (
        <Dialog 
            open={open}
            handleClose={handleClose}
            showCloseButton={false}
            title={title}
            fullWidth={true}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween overflow-inherit'
        >
            <Grid container className='alignitems-center justifycontent-center'>
                <Grid item md={6} sm={5} xs={8} marginBottom={4} marginTop={-16}>
                    <ImageField
                        name='avatar'
                        alt={user?.fullName.toUpperCase()}
                        defaultImage={user?.avatar}
                        height={200}
                        required={false}
                        className='with-border'
                    />
                </Grid>

                <Grid item xs={12}>
                    <Grid container columnSpacing={DefaultConstants.gridColumnSpacing}>
                        <Grid item md={12} sm={6} xs={12}>
                            <TextField
                                type='text'
                                label={translate('fullName')}
                                name='fullName'
                                value={state.values.fullName}
                                onChange={e => state.update(e.target.name, ValidationHelper.MaxLength(e.target.value.trim(), 100))}
                            />
                        </Grid>

                        <Grid item md={12} sm={6} xs={12}>
                            <TextField
                                type='email'
                                label={translate('email')}
                                name='email'
                                value={state.values.email}
                                onChange={e => state.update(e.target.name, ValidationHelper.MaxLength(e.target.value.trim(), 100))}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default MyProfileDialog;